export default __webpack_public_path__ + "static/media/maximize-image-popup.295a72e1.svg";